var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import * as TypeGraphQL from 'type-graphql';
import { PortfolioGreeksHistory } from '../../generated/typegraphql-prisma/models/PortfolioGreeksHistory.mjs';
import { OptionsGreeksHistorySystemSummary } from './OptionsGreeksHistorySystemSummary.mjs';
import { getPrismaFromContext } from '../../generated/typegraphql-prisma/helpers.mjs';
/**
 * Custom resolver for PortfolioGreeksHistory aggregation queries
 * Provides system-wide analytics and summary statistics
 * Note: GraphQL query name remains 'optionsGreeksHistorySystemSummary' for backwards compatibility
 */
let OptionsGreeksHistoryCustomResolver = class OptionsGreeksHistoryCustomResolver {
    /**
     * Get system-wide summary statistics for OptionsGreeksHistory
     * Executes aggregation query to get total accounts, snapshots, and time range
     */
    async optionsGreeksHistorySystemSummary(ctx) {
        const prisma = getPrismaFromContext(ctx);
        // Execute aggregation query
        // This is equivalent to:
        // SELECT
        //   COUNT(DISTINCT account_id) as total_accounts,
        //   COUNT(*) as total_snapshots,
        //   MIN(timestamp) as oldest_snapshot,
        //   MAX(timestamp) as newest_snapshot
        // FROM portfolio_greeks_history
        const [aggregateResult, totalCount] = await Promise.all([
            prisma.portfolioGreeksHistory.aggregate({
                _min: {
                    timestamp: true,
                },
                _max: {
                    timestamp: true,
                },
            }),
            prisma.portfolioGreeksHistory.count(),
        ]);
        // Get distinct account count from the new schema
        const distinctAccounts = await prisma.portfolioGreeksHistory.groupBy({
            by: ['accountId'],
            _count: {
                accountId: true,
            },
        });
        return {
            totalAccounts: distinctAccounts.length,
            totalSnapshots: totalCount,
            oldestSnapshot: aggregateResult._min.timestamp,
            newestSnapshot: aggregateResult._max.timestamp,
        };
    }
};
__decorate([
    TypeGraphQL.Query(_returns => OptionsGreeksHistorySystemSummary, {
        nullable: false,
        description: 'Get system-wide summary statistics for Greeks history data',
    }),
    __param(0, TypeGraphQL.Ctx()),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], OptionsGreeksHistoryCustomResolver.prototype, "optionsGreeksHistorySystemSummary", null);
OptionsGreeksHistoryCustomResolver = __decorate([
    TypeGraphQL.Resolver(_of => PortfolioGreeksHistory)
], OptionsGreeksHistoryCustomResolver);
export { OptionsGreeksHistoryCustomResolver };
//# sourceMappingURL=OptionsGreeksHistoryCustomResolver.js.map